import { store } from '@/store/store'
import { paxtonAppApi } from '@/store/apis/paxton-app-api'
import { nullifyData as chatUxNullify } from '@/chat-common/store/chat-ux.slice'
import { nullifyData as checkoutNullify } from '@/checkout/store/slice'
import { AgentConversationsActions } from '@/agent/conversations/store/slice'
import { ArtifactsActions } from '@/artifacts/store/slice'
import { ArtifactTemplatesActions } from '@/artifact-templates/store/slice'
import { DraftingActions } from '@/drafting/store/slice'
import { AgentResponseMetadataActions } from '@/agent/response_metadata/store/slice'
import { AgentReferencesActions } from '@/agent/references/store/slice'
import { AgentEventsActions } from '@/agent/events/store/slice'
import { AgentConversationFormActions } from '@/agent/chat_form/store/slice'
import { MattersActions } from '@/matter/store/slice'
import { CollaborationActions } from '@/collaboration/store/slice'
import { SkillsActions } from '@/skills/store/slice'
import * as Sentry from '@sentry/browser'
import { ConversationNavigationActions } from '@/chat-common/conversation-navigation/store/slice'
import { AccountActions } from '@/account/store/slice'
import { MedChronJobActions } from '@/medical-chronology/jobs/store/slice'
import { MedChronEventsActions } from '@/medical-chronology/events/store/slice'
import { MedChronReferencesActions } from '@/medical-chronology/references/store/slice'
import { MedChronAssetActions } from '@/medical-chronology/asset/store/slice'
import { TimelineEventsActions } from '@/timeline/events/store/slice'
import { TimelineReferencesActions } from '@/timeline/references/store/slice'
import { TimelineAssetActions } from '@/timeline/asset/store/slice'
import { ResponseFeedbackActions } from '@/response-feedback/store/slice'
import { InlineEditActions } from '@/inline-edit/store/slice'
import { MedSummaryEntriesActions } from '@/medical-billing-summaries/entries/store/entries.slice'
import { MedSummaryEntryEditActions } from '@/medical-billing-summaries/entries/store/entries-edit.slice'
import { MedSummaryReferencesActions } from '@/medical-billing-summaries/references/store/slice'
import { ExternalStorageActions } from '@/user_files/external-storage/store/slice'

/**
 * Clear State Data
 * Handles clearing of various slices of global state
 */
export async function clearReduxStateData() {
  // Chat UX
  store.dispatch(chatUxNullify())

  // Checkout
  store.dispatch(checkoutNullify())

  // Suggested questions
  store.dispatch(paxtonAppApi.util.resetApiState())

  // Matters
  store.dispatch(MattersActions.nullifyData())

  // Collaboration (matter members)
  store.dispatch(CollaborationActions.nullifyData())

  // Skills
  store.dispatch(SkillsActions.nullifyData())

  // Conversation Navigation (last viewed conversations)
  store.dispatch(ConversationNavigationActions.nullifyData())

  // Account
  store.dispatch(AccountActions.nullifyData())

  // External Storage
  store.dispatch(ExternalStorageActions.nullifyData())

  // Medical Billing Summaries
  store.dispatch(MedSummaryEntriesActions.nullifyData())
  store.dispatch(MedSummaryEntryEditActions.nullifyData())
  store.dispatch(MedSummaryReferencesActions.nullifyData())

  // Medical Chronology
  store.dispatch(MedChronJobActions.nullifyData())
  store.dispatch(MedChronEventsActions.nullifyData())
  store.dispatch(MedChronReferencesActions.nullifyData())
  store.dispatch(MedChronAssetActions.nullifyData())

  // Timeline (living asset — events/references/asset slices; no job slice)
  store.dispatch(TimelineEventsActions.nullifyData())
  store.dispatch(TimelineReferencesActions.nullifyData())
  store.dispatch(TimelineAssetActions.nullifyData())

  // Response Feedback
  store.dispatch(ResponseFeedbackActions.nullifyData())

  // Inline Edit
  store.dispatch(InlineEditActions.nullifyData())

  // Agent Conversations
  try {
    store.dispatch(AgentConversationsActions.nullifyData())
    store.dispatch(ArtifactsActions.nullifyData())
    store.dispatch(ArtifactTemplatesActions.nullifyData())
    store.dispatch(DraftingActions.nullifyData())
    store.dispatch(AgentResponseMetadataActions.nullifyData())
    store.dispatch(AgentReferencesActions.nullifyData())
    store.dispatch(AgentEventsActions.nullifyData())
    store.dispatch(AgentConversationFormActions.nullifyData())
  } catch (error) {
    console.warn('Error clearing agent state data:', error)
    Sentry.captureException(error, {
      extra: { onLine: navigator.onLine, cookieEnabled: navigator.cookieEnabled },
    })
  }
}
